import Calendar from '../../Images/svgs/calender.svg'

const CalendarIcon = () => {
  return <img alt='' src={Calendar} />
}

export default CalendarIcon
